import decode from 'jwt-decode';
import auth0 from 'auth0-js';
import Router from 'vue-router';

const ID_TOKEN_KEY = process.env.ID_TOKEN_KEY;
const ACCESS_TOKEN_KEY = process.env.ACCESS_TOKEN_KEY;
const CLIENT_ID = process.env.ID_TOKEN_KEY;
const CLIENT_DOMAIN = process.env.DOMAIN;
const REDIRECT = `${window.location.origin}/callback`;
const SCOPE = 'full_access, openid profile';
const AUDIENCE = process.env.AUDIENCE;

const auth = new auth0.WebAuth({
  clientID: CLIENT_ID,
  domain: CLIENT_DOMAIN
});

export function login() {
  auth.authorize({
    responseType: 'token id_token',
    redirectUri: REDIRECT,
    audience: AUDIENCE,
    scope: SCOPE
  });
}

const router = new Router({
  mode: 'history'
});

export function getIdToken() {
  return localStorage.getItem(ID_TOKEN_KEY);
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function saveUser(data) {
  return localStorage.setItem('user', JSON.stringify(data));
}

export function getUser() {
  if (localStorage.getItem('user')) {
    return JSON.parse(localStorage.getItem('user'));
  }
  return { nickname: '' };
}

function clearIdToken() {
  localStorage.removeItem(ID_TOKEN_KEY);
}

function clearAccessToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

// Helper function that will allow us to extract the access_token and id_token
function getParameterByName(name) {
  const match = RegExp(`[#&]${name}=([^&]*)`).exec(window.location.hash);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

// Get and store access_token in local storage
export function setAccessToken() {
  const accessToken = getParameterByName('access_token');
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
}

// Get and store id_token in local storage
export function setIdToken() {
  const idToken = getParameterByName('id_token');
  localStorage.setItem(ID_TOKEN_KEY, idToken);
}

function getTokenExpirationDate(encodedToken) {
  const token = decode(encodedToken);
  if (!token.exp) {
    return null;
  }

  const date = new Date(0);
  date.setUTCSeconds(token.exp);

  return date;
}

function isTokenExpired(token) {
  const expirationDate = getTokenExpirationDate(token);
  return expirationDate < new Date();
}

export function isLoggedIn() {
  const idToken = getIdToken();
  return !!idToken && !isTokenExpired(idToken);
}

export function getTokenDetails() {
  return decode(getAccessToken());
}

export function logout() {
  const url = location.href.split('/');
  if (url.length >= 5) {
    localStorage.setItem('currentpage', url[url.length - 1]);
  }
  clearIdToken();
  clearAccessToken();
  router.go('/');
}


export function requireAuth(to, from, next) {
  if (!isLoggedIn()) {
    logout();
    next({
      path: '/',
      query: {
        redirect: to.fullPath
      }
    });
  } else {
    next();
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js